import { createSelector } from 'reselect';

const selectRouterState = (state) => state.router;

const selectLocation = createSelector(selectRouterState, (routerState) => routerState.location);

const selectLocationPathname = createSelector(selectLocation, (location) => location.pathname);

const selectLocationState = createSelector(selectLocation, (location) => location.state);

const selectLocationErrorState = createSelector(selectLocationState, (state) => state?.error || {});

export const routerSelectors = {
  selectRouterState,
  selectLocation,
  selectLocationPathname,
  selectLocationState,
  selectLocationErrorState,
};
